export default __webpack_public_path__ + "static/media/logo-man.3595f09e.svg";